'use client';

import type { FC } from 'react';
import { Card, List, Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { HitlCandidate } from '~/app/services/kms/kms-document.types';
import { formatConfidencePercent } from '~/app/services/kms/kms-document.utils';

const { Text } = Typography;

export interface KmsTypeCandidatesCardProps {
  candidates: HitlCandidate[];
}

export const KmsTypeCandidatesCard: FC<KmsTypeCandidatesCardProps> = ({
  candidates,
}) => {
  const { t } = useTranslation('kms');

  if (candidates.length === 0) {
    return null;
  }

  return (
    <Card className="kms-section-card" title={t('detail.candidatesTitle')}>
      <List
        dataSource={candidates}
        renderItem={(candidate) => (
          <List.Item>
            <List.Item.Meta
              title={
                <Space wrap>
                  <Text strong>{candidate.label}</Text>
                  <Tag>{formatConfidencePercent(candidate.score)}</Tag>
                </Space>
              }
              description={candidate.reason}
            />
          </List.Item>
        )}
      />
    </Card>
  );
};
